import styled, { css } from 'styled-components';
import Markdown from 'react-markdown';
import {prop} from 'ramda'

import { WHITE } from '../../utils/colors';
import { ContentContainer } from '../layout/layout.styles';
import { IMAGE_TITLE_COLOR } from '../../utils/colors';
import { ReactComponent as CaptionArrowSVG } from '../../images/caption-arrow.svg';
import { media } from '../../utils/media';
import { MAP_HEIGHTS } from '../../templates/homepage/homepage.constants';

export const TitleWrapper = styled(ContentContainer)`
  
  padding: 15px 0 24px 0;
  margin: 10px 50px 0 40px;

  ${media.tablet`
    margin: 10px auto 0;
  `}
`;

export const Title = styled(Markdown)`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.45px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color};
  p {
    margin-bottom: 0;
  }
`;

export const CaptionWrapper = styled(ContentContainer)`
  position: relative;
`;

export const Caption = styled(Markdown)`
position: absolute;
right: 0;
bottom: 48px;
padding: 3px 7px;
color: ${({ theme }) => theme.color};
background-color: ${WHITE};
font-size: 12px;
font-weight: 500;
line-height: 1.2em;

p {
  margin: 0;
  color: ${({ theme }) => theme.color};
}
a {
  text-decoration: none;
  color: ${({ theme }) => theme.color};
}
`;

export const CaptionArrow = styled(CaptionArrowSVG)`
  position: absolute;
  bottom: 24px;
  path:nth-child(2) {
    fill: ${({ theme }) => theme.color};
  }

  path:nth-child(1) {
    stroke: ${({ theme }) => theme.color};
  }
`;

export const ImageComponent = styled.div`
  width: 100%;
  background: url(${prop('image')}) no-repeat center top;
  background-size: cover;
  background-position: center;

  height: ${MAP_HEIGHTS.mobile}px;

  ${media.bigMobile`
    height: ${MAP_HEIGHTS.bigMobile}px;
  `}

  ${media.tablet`
    height: calc(100vh - 180px);
  `}


  @media print {
    height: ${MAP_HEIGHTS.bigMobile}px;
  }
`;

export const FootnoteWrapper = styled(ContentContainer)`
  margin: 0 50px 0 40px;

  ${media.tablet`
    margin: 0 auto;
  `}
`;

export const Footnote = styled(Markdown)`
  font-size: 12px;
  line-height: 1.5em;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.color};
  margin-bottom: 77px;
`;

export const Container = styled.div`
  padding: 0 0 48px;
  position: relative;
  ${({ displayAsCard }) =>
    displayAsCard &&
    css`
      position: relative;

      ${ImageComponent} {
        position: absolute;
        max-width: 30px;
        left: 10px;
        top: -6px;

        ${media.tablet`
          max-width: 40px;
          left: calc((100% - 1000px) / 2 + 150px);
          top: -12.5px;
        `}

        ${media.desktop`
          left: calc((100% - 1000px) / 2 + 280px);
        `}
      }
    `}
`;
